import axios from "../utils/axios";

export const setTaskDetailById = (id) => {
    return axios.get("/AutonomousMaintenance/GetTaskById?id=" + id);
};

export const getSameLevelListById = (equipmentId) => {
    return axios.get("/Equipment/GetSameLevelListById?equipmentId=" + equipmentId);
};

export const getbreakdownRootCause = () => {
    return axios.get("/BreakdownRootCause/GetList");
};

export const getPoolList = () => {
    return axios.get("/BreakdownReasonGroup/GetList");
};

export const getBreakdownReasonGroupList = () => {
    return axios.get("/BreakdownReasonGroup/GetList");
};
export const getBreakdownEffectList = () => {
    return axios.get("/BreakdownEffect/GetList");
};

export const getTechnicianListByPoolId = (poolId) => {
    return axios.get("/User/GetTechnicianListByPoolId?poolId=" + poolId);
};

export const autonomousMaintenanceAssign = (payload) => {
    console.log(payload, "pay");
    return axios.post(`/AutonomousMaintenance/tasks/${payload.id}/Assign?asigneeCode=${payload.asigneeCode}`);
};

export const startAutonomousMintenance = (data) => {
    return axios.post(`/AutonomousMaintenance/tasks/${data.id}/Start`);
};

export const autonomousMaintenanceCloaseComplete = (payload) => {
    return axios.post(`/AutonomousMaintenance/tasks/${payload.id}/Complete`, payload.data);
};

export const saveAutonomousMintenance = (payload) => {
    console.log(payload, "payload");
    return axios.post(`/AutonomousMaintenance/tasks/${payload.id}/Save`, payload);
};

export const closeAutonomousMintenance = (payload) => {
    return axios.post(`/AutonomousMaintenance/tasks/${payload.id}/Close`);
};

export const autonomousMaintenancePause = (data) => {
    return axios.post("/AutonomousMaintenance/Pause?taskId=" + data.id + "&pauseReasonId=" + data.selectedMaintenancePauseReasonCode + "&pauseReasonNote=" + data.maintenancePauseNote);
};

export const autonomousMaintenanceUpdateTask = (data) => {
    return axios.post("/AutonomousMaintenance/UpdateTask", data);
};
export const AddTechnician = (data) => {
    return axios.post("/AutonomousMaintenance/AddTechnician?taskId=" + data.id + "&userCode=" + data.selectedFriend);
};
export const BreakdownReasonPlaceByGroupId = (data) => {
    return axios.get("/BreakdownReasonPlace/GetListByGroupId?breakdownGroupId=" + data);
};
export const BreakdownReasonDetail = (data) => {
    return axios.get("/BreakdownReasonDetail/GetListByPlaceId?breakdownReasonPlaceId=" + data);
};

export const getAutonomousFiles = (id) => {
    return axios.get(`/AutonomousMaintenance/${id}/Files`, { responseType: "arraybuffer" });
};

export const addAutonomousFiles = (payload) => {
    return axios.post(`/AutonomousMaintenance/${payload.autonomousId}/Files`, payload.data);
};

export const MaintenancePauseReason = () => {
    return axios.get("/MaintenancePauseReason/GetList");
};

export const getTaskHistoryById = (data) => {
    return axios.get("/AutonomousMaintenance/GetTaskHistoryById?id=" + data.id);
};

export const deleteTask = (data) => {
    return axios.post("AutonomousMaintenance/DeleteTask?autonomousMaintenanceOrderTaskId=" + data.id + `&deleteFutureTasks=${data.flag}`);
};

export const deleteAutonomousFiles = (payload) => {
    return axios.delete(`/AutonomousMaintenance/${payload.autonomousId}/Files`, { data: payload.fileNames });
};
